import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material';
import {ConfirmationDialogComponent} from './confirmation-dialog.component';
import {DialogButtonType} from "./ConfirmationDialog.model";


@Injectable()
export class ConfirmationDialogNotificationService {
  constructor(private dialog: MatDialog) {
  }

  public open(confirmMessage: string = null, confirmButtonText = null, confirm, cancel = null, dialogType = DialogButtonType.SUCCESS) {
    const data = {
      confirmMessage: confirmMessage,
      confirmButtonText: confirmButtonText,
      dialogType: dialogType
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: data,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        confirm();
      } else if (cancel != null) {
        cancel();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/confirmation-dialog/confirmation-dialog-notification.service.ts